import { Breadcrumb, Button, Card, Col, Empty, InputNumber, message, Modal, Row, Select, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { GTeacher, USER_SOURCE_TO_NAME, UserSource } from 'src/types/teacher';
import { createMapBy } from 'src/utils/collections';

import { Sku } from '../enrollment/Enrollment';
import { EditableTable } from './EditableTable';

const { Option } = Select;
export interface SkusData {
  skus: Sku[];
}
export const getTeacherAllocationQuery = gql`
  query getTeacherAllocationQuery($ids: [ID]) {
    skus(ids: $ids) {
      id
      name
      teacherAllocations {
        id
        turns
        round
        groupPolicy
        groupSize
        userSource
        teacher {
          id
          name
        }
        teacherId
        skuId
      }
    }
  }
`;

export const teachersQuery = gql`
  query getTeachersQuery {
    teachers {
      id
      name
    }
  }
`;

export interface TeacherAllocation {
  id: number;
  turns: number;
  groupPolicy: number;
  round: number;
  groupSize: number;
  teacher: GTeacher;
  teacherId: number;
  skuId: number;
  userSource: UserSource;
}

enum addType {
  ADD_ROUND,
  ADD_TEACHER,
}

export enum GroupPolicy {
  NEW, // 新开班
  EXPANSION, // 扩容
}

export const createTeacherAllocationMutation = gql`
  mutation createTeacherAllocation(
    $groupPolicy: Int
    $groupSize: Int
    $round: Int
    $skuId: ID!
    $teacherId: ID
    $turns: Int
    $userSource: Int
  ) {
    createTeacherAllocation(
      groupPolicy: $groupPolicy
      groupSize: $groupSize
      round: $round
      skuId: $skuId
      teacherId: $teacherId
      turns: $turns
      userSource: $userSource
    ) {
      id
    }
  }
`;

interface State {
  roundList: number[];
  isShowAddTeacherAllocationModal: boolean;
  addType: number;
  addTeacherId: number;
  groupPolicy: number;
  groupSize: number;
  turns: number;
  round: number;
  turnsTmp: string;
  userSource: number;
}

export class AllocateTeacher extends Component<RouteComponentProps<{ skuId: string }>, State> {
  constructor(props: RouteComponentProps<{ skuId: string }>) {
    super(props);
    this.state = {
      roundList: [],
      isShowAddTeacherAllocationModal: false,
      addType: 0,
      addTeacherId: 0,
      groupSize: 0,
      groupPolicy: 0,
      turns: 0,
      round: 0,
      turnsTmp: '',
      userSource: 0,
    };
  }

  addRound = () => {
    this.setState({ isShowAddTeacherAllocationModal: true, addType: 0 });
  };

  addTeacher = (teacherAllocations: TeacherAllocation[]) => {
    const { round, groupPolicy, groupSize } = teacherAllocations[0];
    this.setState({ round, groupPolicy, groupSize, addType: 1, isShowAddTeacherAllocationModal: true });
  };

  getGroupSize = (value: number) => {
    this.setState({ groupSize: value });
  };

  getLeftTurns = (value: number) => {
    this.setState({ turns: value });
  };

  addTeacherAndRoundModal() {
    const { turns, groupPolicy, groupSize, addTeacherId, userSource } = this.state;
    let { round } = this.state;
    if (this.state.addType === addType.ADD_ROUND) {
      round = 0;
    }
    return (
      <div>
        <Mutation
          mutation={createTeacherAllocationMutation}
          variables={{
            groupPolicy,
            groupSize,
            round,
            turns,
            userSource,
            skuId: this.props.match.params.skuId,
            teacherId: addTeacherId,
          }}
          refetchQueries={[
            {
              query: getTeacherAllocationQuery,
              variables: { ids: [this.props.match.params.skuId] },
            },
          ]}
        >
          {(addTeacherAllocation, { loading }) => {
            return (
              <Modal
                title="添加"
                visible={this.state.isShowAddTeacherAllocationModal}
                onOk={async () => {
                  if (this.state.addTeacherId === 0 || this.state.turns === 0) {
                    message.warning('请填写完整信息！');
                    return;
                  }
                  if (loading) {
                    return;
                  }
                  try {
                    await addTeacherAllocation();
                    this.setState({ isShowAddTeacherAllocationModal: false });
                  } catch (e) {
                    message.error('添加失败！');
                  }
                }}
                onCancel={this.cancelAddTeacherAllocation}
              >
                <div>
                  {this.state.addType === addType.ADD_ROUND && (
                    <Row>
                      <Col span={14}>
                        <span>分配类型：</span>
                        <Select
                          style={{ width: 100 }}
                          value={this.state.groupPolicy}
                          onChange={(value: number) => {
                            this.setState({ groupPolicy: value });
                          }}
                        >
                          <Option value={GroupPolicy.NEW}>新建班级</Option>
                          <Option value={GroupPolicy.EXPANSION}>扩容班级</Option>
                        </Select>
                      </Col>
                      <Col span={10}>
                        <span>分配学生数量：</span>
                        <InputNumber onChange={this.getGroupSize} />
                      </Col>
                    </Row>
                  )}
                  <Query query={teachersQuery}>
                    {({ loading, error, data }) => {
                      if (error) return <div>{error.message}</div>;
                      if (!data) {
                        // @ts-ignore
                        return <Empty />;
                      }
                      const teachers = data.teachers || [];
                      return (
                        <Row style={{ marginTop: 10 }}>
                          <Col span={14}>
                            <span>选择老师：</span>
                            <Select
                              showSearch
                              style={{ width: 150 }}
                              placeholder="Select a teacher"
                              optionFilterProp="children"
                              value={this.state.addTeacherId}
                              onChange={(value: number) => {
                                this.setState({ addTeacherId: value });
                              }}
                            >
                              <Select.Option value={0} key="0">
                                请选择
                              </Select.Option>
                              {teachers.map((teacher: { id: number; name: string }) => {
                                return (
                                  <Select.Option value={teacher.id} key={teacher.id}>
                                    {teacher.name}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                          </Col>
                          <Col span={10}>
                            剩余分配次数：
                            <InputNumber value={this.state.turns} onChange={this.getLeftTurns} />
                          </Col>
                        </Row>
                      );
                    }}
                  </Query>
                  <Row>
                    {' '}
                    <Col span={14}>
                      <span>学生来源：</span>
                      <Select
                        style={{ width: 100 }}
                        value={this.state.userSource}
                        onChange={(value: number) => {
                          this.setState({ userSource: value });
                        }}
                      >
                        <Option value={UserSource.NORMAL}>{USER_SOURCE_TO_NAME[UserSource.NORMAL]}</Option>
                        <Option value={UserSource.SLM}>{USER_SOURCE_TO_NAME[UserSource.SLM]}</Option>
                      </Select>
                    </Col>
                  </Row>
                </div>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }

  addTeacherAllocationConfirmClick = () => {
    this.setState({ isShowAddTeacherAllocationModal: false });
  };

  cancelAddTeacherAllocation = () => {
    this.setState({ isShowAddTeacherAllocationModal: false, addTeacherId: 0, turns: 0 });
  };

  teacherAllocationOrder(teacherAllocations: TeacherAllocation[]) {
    const orderList = teacherAllocations.map(teacherAllocation => ({
      id: teacherAllocation.id,
      turns: teacherAllocation.turns,
      teacherName: teacherAllocation.teacher.name,
    }));
    let len = orderList.reduce((v, a) => {
      return v + a.turns;
    }, 0);
    len = len > 30 ? 30 : len;
    const teacherOrderList: string[] = [];
    for (let i = 0; i < len; i += 1) {
      orderList.sort((a, b) => {
        if (a.turns === b.turns) {
          return a.id - b.id;
        }
        return b.turns - a.turns;
      });
      orderList[0].turns -= 1;
      teacherOrderList.push(orderList[0].teacherName);
    }
    return <span>{teacherOrderList.join(' - ')}</span>;
  }

  render() {
    const { skuId } = this.props.match.params;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/group/skus/group`}>社群管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>配置班主任</Breadcrumb.Item>
        </Breadcrumb>
        <Query<SkusData> query={getTeacherAllocationQuery} fetchPolicy="cache-and-network" variables={{ ids: [skuId] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const { skus = [] } = data || {};
            if (!skus.length) {
              return null;
            }
            const [sku] = skus;
            const { teacherAllocations } = sku;
            // TODO roundList optimization
            const map = createMapBy(teacherAllocations, 'round');
            const roundList = [...new Set(teacherAllocations.map(v => v.round))];

            return (
              <>
                <div style={{ fontSize: '30px', padding: '20px 0', fontWeight: 'bolder', background: '#fff' }}>
                  <Link to={`/group/list/${sku.id}`} style={{ marginLeft: 5 }}>
                    {sku.name}
                  </Link>
                </div>
                <Card title="配置班主任">
                  <Card>
                    <Row>
                      <Col span={12}>
                        <Button type="primary" onClick={this.addRound}>
                          添加轮次
                        </Button>
                        {this.addTeacherAndRoundModal()}
                      </Col>
                    </Row>
                  </Card>
                  <div>
                    {roundList.map(round => {
                      const teacherAllocations = map.get(round);
                      if (!teacherAllocations) {
                        return;
                      }
                      const target = teacherAllocations.findIndex(v => v.turns > 0);
                      let isEditable = false;
                      if (target > -1) {
                        isEditable = true;
                      }
                      const { groupPolicy, groupSize } = teacherAllocations[0];
                      return (
                        <div key={`${round}`}>
                          <Row style={{ marginBottom: 10, marginTop: 20 }}>
                            <Col span={12}>
                              <span style={{ fontSize: '30px' }}>R{round}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={6}>
                              <span>分配类型：{groupPolicy === 0 ? '新建班级' : '扩容班级'}</span>
                            </Col>
                            <Col span={6}>
                              <span>分配学生数量： {groupSize}</span>
                            </Col>
                          </Row>
                          <div style={{ padding: '10px 0' }}>
                            {isEditable && (
                              <Button type="primary" onClick={() => this.addTeacher(teacherAllocations)}>
                                添加老师
                              </Button>
                            )}
                          </div>
                          {isEditable ? (
                            <EditableTable
                              teacherAllocations={teacherAllocations}
                              skuId={this.props.match.params.skuId}
                            />
                          ) : (
                            <Table
                              dataSource={teacherAllocations}
                              pagination={false}
                              bordered
                              rowKey={`${round}`}
                              loading={loading}
                            >
                              <Table.Column title="ID" dataIndex="id" key="id" />
                              <Table.Column title="老师" dataIndex="teacher.name" key="teacherName" />
                              <Table.Column
                                title="学生来源"
                                dataIndex="userSource"
                                key="userSource"
                                render={userSource => USER_SOURCE_TO_NAME[userSource]}
                              />
                              <Table.Column title="剩余分配次数" dataIndex="turns" key="turns" />
                            </Table>
                          )}
                          <div style={{ margin: '5px 0 20px' }}>{this.teacherAllocationOrder(teacherAllocations)}</div>
                        </div>
                      );
                    })}
                    <Row style={{ padding: '10px 0' }}>
                      <Col span={6}>
                        <Button
                          onClick={() => {
                            this.props.history.goBack();
                          }}
                        >
                          返回
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/AllocateTeacher.tsx